import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    patientKyc: {},
    documents: {}
}

const fullScanSlice = createSlice({
    name: 'patientKyc',
    initialState,
    reducers: {
        clearData: () => {
            return initialState
        },
        addPatientData: (state, action) => {
            state.patientKyc = { ...action.payload }
        },
        addPatientDocuments: (state, action) => {
            state.documents = {
                ...state.documents,
                ...action.payload
            }
        }
    }
})

export default fullScanSlice.reducer
export const { clearData, addPatientData, addPatientDocuments } = fullScanSlice.actions